import {BrandSubscriptionPlatform} from '@/utils/brand-subscription/constants'
import {CaseSolutionItemType} from '@/utils/case-solution/constants'
import {Jurisdiction} from '@/utils/countries/constants'

const caseSolutionTakedownContent = {
  imageSrc: '/images/icons/takedown.svg',
  imageAlt: 'Takedown',
  title: 'case-solutions.takedown-title',
  description: 'case-solutions.takedown-description',
  longDescription: 'case-solutions.takedown-long-description',
  pricingDescription: 'case-solutions.takedown-pricing-description',
  offeredSubscription: {
    description: 'case-solutions.takedown-offered-subscription-description',
  },
}

const caseSolutionOppositionDefaultContent = {
  title: 'case-solutions.opposition-default-title',
  description: 'case-solutions.opposition-default-description',
  longDescription: 'case-solutions.opposition-default-long-description',
}

const caseSolutionOppositionContent = {
  [Jurisdiction.US]: {
    ['default']: {
      title: 'case-solutions.us-opposition-default-title',
      description: 'case-solutions.us-opposition-default-description',
      longDescription: 'case-solutions.us-opposition-default-long-description',
    },
    ['extension-request']: {
      title: 'case-solutions.us-opposition-extension-request-title',
      description: 'case-solutions.us-opposition-extension-request-description',
      longDescription: 'case-solutions.us-opposition-extension-request-long-description',
    },
  },
  [Jurisdiction.UK]: {
    ['threatened']: {
      title: 'case-solutions.uk-opposition-threatened-title',
      description: 'case-solutions.uk-opposition-threatened-description',
      longDescription: 'case-solutions.uk-opposition-threatened-long-description',
    },
    ['with-reasoning']: {
      title: 'case-solutions.uk-opposition-with-reasoning-title',
      description: 'case-solutions.uk-opposition-with-reasoning-description',
      longDescription: 'case-solutions.uk-opposition-with-reasoning-long-description',
    },
    ['without-reasoning']: {
      title: 'case-solutions.uk-opposition-without-reasoning-title',
      description: 'case-solutions.uk-opposition-without-reasoning-description',
      longDescription: 'case-solutions.uk-opposition-without-reasoning-long-description',
      pricingTitle: 'case-solutions.uk-opposition-without-reasoning-pricing-title',
      pricingDescription: 'case-solutions.uk-opposition-without-reasoning-pricing-description',
    },
    ['more-grounds']: {
      title: 'case-solutions.uk-opposition-more-grounds-title',
      description: 'case-solutions.uk-opposition-more-grounds-description',
      longDescription: 'case-solutions.uk-opposition-more-grounds-long-description',
    },
    ['fasttrack']: {
      title: 'case-solutions.uk-opposition-fasttrack-title',
      description: 'case-solutions.uk-opposition-fasttrack-description',
      longDescription: 'case-solutions.uk-opposition-fasttrack-long-description',
    },
    ['substantive-action']: {
      title: 'case-solutions.uk-opposition-substantive-action-title',
      description: 'case-solutions.uk-opposition-substantive-action-description',
      longDescription: 'case-solutions.uk-opposition-substantive-action-long-description',
    },
  },
  [Jurisdiction.EU]: {
    ['with-reasoning']: {
      title: 'case-solutions.eu-opposition-with-reasoning-title',
      description: 'case-solutions.eu-opposition-with-reasoning-description',
      longDescription: 'case-solutions.eu-opposition-with-reasoning-long-description',
      pricingTitle: 'case-solutions.eu-opposition-with-reasoning-pricing-title',
      pricingDescription: 'case-solutions.eu-opposition-with-reasoning-pricing-description',
    },
    ['without-reasoning']: {
      title: 'case-solutions.eu-opposition-without-reasoning-title',
      description: 'case-solutions.eu-opposition-without-reasoning-description',
      longDescription: 'case-solutions.eu-opposition-without-reasoning-long-description',
    },
    ['substantive-action']: {
      title: 'case-solutions.eu-opposition-substantive-action-title',
      description: 'case-solutions.eu-opposition-substantive-action-description',
      longDescription: 'case-solutions.eu-opposition-substantive-action-long-description',
    },
  },
  [Jurisdiction.DE]: {
    ['default']: caseSolutionOppositionDefaultContent,
  },
  [Jurisdiction.ES]: {
    ['default']: caseSolutionOppositionDefaultContent,
  },
  [Jurisdiction.IT]: {
    ['default']: caseSolutionOppositionDefaultContent,
  },
  [Jurisdiction.FR]: {
    ['default']: caseSolutionOppositionDefaultContent,
  },
}

const caseSolutionCeaseDesistLetterContent = {
  ['simple']: {
    title: 'case-solutions.c&d-letter-simple-title',
    description: 'case-solutions.c&d-letter-simple-description',
    longDescription: 'case-solutions.c&d-letter-simple-long-description',
    pricingDescription: 'case-solutions.c&d-letter-simple-pricing-description',
    offeredSubscription: {
      description: 'case-solutions.c&d-letter-simple-offered-subscription-description',
    },
  },
  ['package']: {
    title: 'case-solutions.c&d-letter-package-title',
    description: 'case-solutions.c&d-letter-package-description',
    longDescription: 'case-solutions.c&d-letter-package-long-description',
    offeredSubscription: {
      description: 'case-solutions.c&d-letter-package-offered-subscription-description',
    },
  },
}

const caseSolutionNegotiationsContent = {
  title: 'case-solutions.negotiations-title',
  description: 'case-solutions.negotiations-description',
  longDescription: 'case-solutions.negotiations-long-description',
  pricingDescription: 'case-solutions.negotiations-pricing-description',
}

const caseSolutionWarningLetterContent = {
  title: 'case-solutions.warning-letter-title',
  description: 'case-solutions.warning-letter-description',
  longDescription: 'case-solutions.warning-letter-long-description',
  pricingDescription: 'case-solutions.warning-letter-pricing-description',
  offeredSubscription: {
    description: 'case-solutions.warning-letter-offered-subscription-description',
  },
}

const caseSolutionDomainDisputeContent = {
  ['resolution']: {
    title: 'case-solutions.domain-dispute-resolution-title',
    description: 'case-solutions.domain-dispute-resolution-description',
    longDescription: 'case-solutions.domain-dispute-resolution-long-description',
    pricingDescription: 'case-solutions.domain-dispute-resolution-pricing-description',
  },
  ['observations']: {
    title: 'case-solutions.domain-dispute-observations-title',
    description: 'case-solutions.domain-dispute-observations-description',
    longDescription: 'case-solutions.domain-dispute-observations-long-description',
  },
}

const caseSolutionCancellationContent = {
  [Jurisdiction.US]: {
    ['default']: {
      title: 'case-solutions.us-cancellation-title',
      description: 'case-solutions.us-cancellation-description',
      longDescription: 'case-solutions.us-cancellation-long-description',
    },
  },
  [Jurisdiction.UK]: {
    ['with-reasoning']: {
      title: 'case-solutions.uk-cancellation-with-reasoning-title',
      description: 'case-solutions.uk-cancellation-with-reasoning-description',
      longDescription: 'case-solutions.uk-cancellation-with-reasoning-long-description',
    },
    ['substantive-action']: {
      title: 'case-solutions.uk-cancellation-substantive-action-title',
      description: 'case-solutions.uk-cancellation-substantive-action-description',
      longDescription: 'case-solutions.uk-cancellation-substantive-action-long-description',
    },
  },
  [Jurisdiction.EU]: {
    ['with-reasoning']: {
      title: 'case-solutions.eu-cancellation-with-reasoning-title',
      description: 'case-solutions.eu-cancellation-with-reasoning-description',
      longDescription: 'case-solutions.eu-cancellation-with-reasoning-long-description',
      pricingTitle: 'case-solutions.eu-cancellation-with-reasoning-pricing-title',
      pricingDescription: 'case-solutions.eu-cancellation-with-reasoning-pricing-description',
    },
    ['request-without-reasoning']: {
      title: 'case-solutions.eu-cancellation-request-without-reasoning-title',
      description: 'case-solutions.eu-cancellation-request-without-reasoning-description',
      longDescription: 'case-solutions.eu-cancellation-request-without-reasoning-long-description',
    },
    ['substantive-action']: {
      title: 'case-solutions.eu-cancellation-substantive-action-title',
      description: 'case-solutions.eu-cancellation-substantive-action-description',
      longDescription: 'case-solutions.eu-cancellation-substantive-action-long-description',
    },
  },
}

const caseSolutionLegalConsultationContent = {
  imageSrc: '/images/icons/consultation.svg',
  imageAlt: 'Legal consultation',
  title: 'case-solutions.legal-consultation-title',
  description: 'case-solutions.legal-consultation-description',
  longDescription: 'case-solutions.legal-consultation-long-description',
  pricingDescription: 'case-solutions.legal-consultation-pricing-description',
  offeredSubscription: {
    description: 'case-solutions.legal-consultation-offered-subscription-description',
  },
}

const caseSolutionUsLetterOfProtestContent = {
  title: 'case-solutions.us-letter-of-protest-title',
  description: 'case-solutions.us-letter-of-protest-description',
  longDescription: 'case-solutions.us-letter-of-protest-long-description',
  pricingDescription: 'case-solutions.us-letter-of-protest-pricing-description',
  offeredSubscription: {
    description: 'case-solutions.us-letter-of-protest-offered-subscription-description',
  },
}

const caseSolutionsContent: Record<CaseSolutionItemType, any> = {
  [CaseSolutionItemType.takedown]: caseSolutionTakedownContent,
  [CaseSolutionItemType.opposition]: caseSolutionOppositionContent,
  [CaseSolutionItemType.warningLetter]: caseSolutionWarningLetterContent,
  [CaseSolutionItemType.ceaseDesistLetter]: caseSolutionCeaseDesistLetterContent,
  [CaseSolutionItemType.negotiations]: caseSolutionNegotiationsContent,
  [CaseSolutionItemType.domainDispute]: caseSolutionDomainDisputeContent,
  [CaseSolutionItemType.cancellation]: caseSolutionCancellationContent,
  [CaseSolutionItemType.legalConsultation]: caseSolutionLegalConsultationContent,
  [CaseSolutionItemType.usLetterOfProtest]: caseSolutionUsLetterOfProtestContent,
}

type SolutionItemContentType = {
  imageSrc?: string
  imageAlt?: string
  title: string
  description: string
  longDescription?: string
  pricingTitle?: string
  pricingDescription?: string
  offeredSubscription?: {description: string}
}

export const getSolutionItemContent = (
  type: CaseSolutionItemType,
  platform?: BrandSubscriptionPlatform,
  jurisdiction?: Jurisdiction,
  option?: string,
): SolutionItemContentType => {
  if (type === CaseSolutionItemType.opposition) {
    if (jurisdiction && option) {
      return caseSolutionsContent[type][jurisdiction][option]
    }
  } else if (type === CaseSolutionItemType.cancellation) {
    if (jurisdiction) {
      if (option) {
        return caseSolutionsContent[type][jurisdiction][option]
      } else {
        return caseSolutionsContent[type][jurisdiction]['default']
      }
    }
  } else if (
    type === CaseSolutionItemType.ceaseDesistLetter ||
    type === CaseSolutionItemType.domainDispute
  ) {
    if (option) {
      return caseSolutionsContent[type][option]
    }
  }

  return caseSolutionsContent[type]
}
